import { render, staticRenderFns } from "./FlexmessageBoxAction.vue?vue&type=template&id=32889581&scoped=true&"
import script from "./FlexmessageBoxAction.vue?vue&type=script&lang=js&"
export * from "./FlexmessageBoxAction.vue?vue&type=script&lang=js&"
import style0 from "./FlexmessageBoxAction.vue?vue&type=style&index=0&id=32889581&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32889581",
  null
  
)

export default component.exports